import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  contentContainer: {
    padding: 12,
  },
  // titleLayout: {
  //   //padding: '1.5rem 1rem',
  //   padding: 20,
  //   backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
  //   color: 'white',
  //   borderRadius: '0 !important',
  // },
  // cardLayout: {
  //   marginBottom: '1.2rem',
  //   //width: '95%',
  //   marginLeft: 10,
  //   // margin: 'auto',
  //   fontWeight: 300,
  // },
  tableHeader: {
    background: 'white',
    border: '1px solid rgb(224 224 224)',
    // borderRadius: '.4rem',
    borderBottom: 'none',
    padding: '1rem .5rem',
    color: '#515151',
  },
  titleLayout: {
    padding: 20,
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
  },
  cardLayout: {
    marginBottom: 6,
    marginLeft: 12,
  },
  tableList: {
    marginTop: 12,
    marginBottom: 6,
  },
  dashboardButton: {
    //float: 'right',
    marginTop: 6,
    marginBottom: 6,
    marginRight: 12,
    //width: '99%',
  },
}));

export default useStyles;
